export default __webpack_public_path__ + "static/media/iPhone-Premium-2.58cefba4.png";